import { styled } from '../jss-style';
import gapStyle from './gap';

const useGapStyle = styled(gapStyle, 'gap');

export { gapStyle, useGapStyle };
export default useGapStyle;